import api from '@/services/Api'

export default {
    infoUser (data) { // Liste tout
        return api().get(`/tools/infoUser/${encodeURIComponent(data)}`)
    },
}
